import PropTypes from 'prop-types'

import { Columns } from '@domain-group/suit-theme'

import useBrand from '@hooks/useBrand'
import useCurrentUser from '@hooks/useCurrentUser'
import useRoles from '@hooks/useRoles'

import EntityUsers from '@components/EntityUsers'
import ScopedConditionalContent from '@components/ScopedConditionalContent'

import BrandInactiveBanner from '../../../../components/BrandInactiveBanner'
import BrandTools from '../../../../components/BrandTools'
import PageLayout from '../../../../components/PageLayout'

import BrandAgencies from '../BrandAgencies'
import BrandProviders from '../BrandProviders'
import BrandTemplateDevelopers from '../BrandTemplateDevelopers'

const PageContent = (props) => {
  const { brandId } = props

  const brandPayload = useBrand({ id: brandId })
  const { brand, requireTemplateSpecialists } = brandPayload

  const { isAdmin, isBrandUser } = useCurrentUser()

  const { filteredRoles, loading } = useRoles({ filters: { string: 'Brand Administrator' } })
  const brandRole = filteredRoles[0] || {}

  return (
    <PageLayout entityPayload={brandPayload} activeTabBarItemKey="relations">
      <Columns.Main>
        {brand.hidden && (
          <BrandInactiveBanner brandPayload={brandPayload} />
        )}

        <BrandAgencies brandId={brandId} />

        <EntityUsers
          filters={{ brand_id: brandId, role_id: brandRole.id }}
          initUser={{ association_id: brandId, association_type: 'Brand', role_id: brandRole.id }}
          loading={loading}
          performHttpRequests={!!brandId && !!brandRole.id}
        />

        <BrandProviders brandId={brandId} />

        <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
          {requireTemplateSpecialists && <BrandTemplateDevelopers brandId={brandId} /> }
        </ScopedConditionalContent>
      </Columns.Main>

      <Columns.Sidebar>
        {(isAdmin || isBrandUser) && (
          <BrandTools brandPayload={brandPayload} />
        )}
      </Columns.Sidebar>
    </PageLayout>
  )
}

PageContent.propTypes = {
  brandId: PropTypes.number.isRequired,
}

export default PageContent
